export default {
  lighthouse: {
    apiHost: 'https://lighthouse-api-staging.harbortouch.com',
  },
};
